import {
    LOGIN_ROUTE,
    REGISTRATION_ROUTE,
    BASKET_ROUTE,
    SHOES_ROUTE,
    TOYS_ROUTE,
    PRODUCT_ROUTE,
    STORE_INFO_ROUTE,
    UNIVERSAL_REPORT_ROUTE,
    ADMIN_ROUTE
} from './utils/consts';
import Basket from "./pages/Basket";
import Shop from "./pages/Shop";
import Auth from "./pages/Auth";
import ProductPage from "./pages/ProductPage";
import HomePage from "./components/HomePage";
import ShoesPage from "./components/ShoesPage";
import StoreInfo from "./pages/StoreInfo";
import UniversalReport from "./components/UniversalReport/UniversalReport";
import AdminPanel from "./components/AdminPanel";
import UserAgreement from './pages/UserAgreement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import VerifyEmail from './pages/VerifyEmail';
import ConsentPersonalData from './pages/ConsentPersonalData';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

export const authRoutes = [
    {
        path: ADMIN_ROUTE,
        Component: AdminPanel
    },
    {
        path: UNIVERSAL_REPORT_ROUTE,
        Component: UniversalReport
    }
];

export const publicRoutes = [
    {
        path: '/',
        Component: HomePage
    },
    {
        path: SHOES_ROUTE,
        Component: ShoesPage
    },
    {
        path: TOYS_ROUTE,
        Component: Shop
    },
    {
        path: '/shop',
        Component: Shop
    },
    {
        path: LOGIN_ROUTE,
        Component: Auth
    },
    {
        path: REGISTRATION_ROUTE,
        Component: Auth
    },
    {
        path: PRODUCT_ROUTE + '/:id',
        Component: ProductPage
    },
    {
        path: BASKET_ROUTE,
        Component: Basket
    },
    {
        path: STORE_INFO_ROUTE,
        Component: StoreInfo
    },
    {
        path: '/user-agreement',
        Component: UserAgreement
    },
    {
        path: '/privacy-policy',
        Component: PrivacyPolicy
    },
    {
        path: '/verify-email',
        Component: VerifyEmail
    },
    {
        path: '/consent-personal-data',
        Component: ConsentPersonalData
    },
    {
        path: '/forgot-password',
        Component: ForgotPassword
    },
    {
        path: '/reset-password',
        Component: ResetPassword
    }
];